<template>
  <div :class="[overrideStyle ? '' : 'px3 py2 white-bg']">
    <div v-for="(route, index) in breadcrumbRoutes" :key="index" class="inline" @click="router.push({name: route.name})">
      <span class="h6n bold" :class="index < breadcrumbRoutes.length-1?'cyan pointer':''">{{ route.title }}</span> <span v-if="index < breadcrumbRoutes.length-1"> > </span>
    </div>
  </div>
</template>
<script>

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default {
  props: {
    overrideStyle: {
      type: Boolean,
      default: false
    },
    startFrom: {
      type: Number,
      default: 1
    }
  },
  setup (props) {
    const route = useRoute();
    const router = useRouter();

    const breadcrumbRoutes = computed(() => {
      const routes = [];
      route.matched.map((match, index) => {
        if (index > props.startFrom) {
          routes.push({
            name: match.name,
            title: match.meta.title
          });
        }
      });

      return routes;
    });

    return { route, router, breadcrumbRoutes };
  }
};
</script>

<style>
</style>
